__turbopack_context__.v({
  "tabs": "tabs-module-scss-module__rOGP7q__tabs",
  "tabs-list": "tabs-module-scss-module__rOGP7q__tabs-list",
  "tabs-trigger": "tabs-module-scss-module__rOGP7q__tabs-trigger",
});
